import { ImportExportHistoryColumn } from '@/components/ImportExportHistory/type';
import { formatFileSize } from '@/utils/convert/formatFileSize';
import { FC, memo } from 'react';

type Props = {
  row: ImportExportHistoryColumn;
};

export const FileSizeCell: FC<Props> = memo(({ row }) => {
  const value = row.byte_size !== null ? formatFileSize(row.byte_size) : '--';
  return <span>{value}</span>;
});

FileSizeCell.displayName = 'FileSizeCell';
